import React, { createContext, useContext, useState, useEffect } from "react";
import type { WizardOptions } from "../constants/onboardingFallbacks";
import { fetchWizardOptions } from "../utils/wizardOptionsApi";

const emptyOptions: WizardOptions = {
  countries: [], degreeLevels: [], studyAreas: [],
  cities: [], nearestOffices: [], coachingOptions: [],
};

const WizardOptionsContext = createContext<WizardOptions>(emptyOptions);

interface WizardOptionsProviderProps {
  value: WizardOptions;
  children: React.ReactNode;
}

export const WizardOptionsProvider: React.FC<WizardOptionsProviderProps> = ({
  value,
  children,
}) => {
  const [options, setOptions] = useState<WizardOptions>(value);

  useEffect(() => {
    let cancelled = false;
    fetchWizardOptions()
      .then((live) => {
        if (!cancelled) setOptions(live);
      })
      .catch(() => { /* keep seeded fallback */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <WizardOptionsContext.Provider value={options}>
      {children}
    </WizardOptionsContext.Provider>
  );
};

export const useWizardOptions = (): WizardOptions => {
  return useContext(WizardOptionsContext);
};
